import React, { useEffect } from "react";
import Typography from '@mui/material/Typography';
import ReactQuill from 'react-quill';

import { Grid } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../components/common/FormikControl";
import { useDispatch, useSelector } from "react-redux";
import 'react-quill/dist/quill.snow.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
    addNewFaq,
    allModules,
    allprocessListByModuleId,
    allProcessLists,
    clearDetailOfFaq,
    enableIsReadonly,
    enableModule,
    enableProcess,
    fetchAllModules,
    isReadonlyFeild,
    listingByProcessId,
    Loading,
    processDetail,
    processesByModuleId,
    selectedModule,
    selectedProcess,
    updateFaq
} from '../../../slices/help';
import { BackNavIcon } from "../../../../assets/common-svg/CommonSvg";
import { NAME_REGEX, SANITISE_REGEX } from "../../../../utils/common";

const validationSchema = Yup.object().shape({
    module: Yup.string().required("Module is required"),
    process: Yup.string().required("Process is required"),
    title: Yup.string()
        .min(1, " Title must be between 1-100 characters long")
        .max(100, " Title must be between 1-100 characters long")
        .matches(NAME_REGEX, "Enter a valid Principal Title")
        .test(
            "no-zalgo",
            "Glitch text is not allowed",
            value => !SANITISE_REGEX.test(value || "")
        )
        .required(" Title is required"),
    content: Yup.string()
        .required("Content is required")
        .test("is-not-empty", "Content is required", value => {
            const stripped = value?.replace(/<[^>]*>/g, "").trim();
            return stripped?.length > 0;
        })
});

const modules = {
    toolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults
        [{ 'font': [] }],
        [{ 'align': [] }],
        ['link', 'image', 'video'],                       // add image and video
        ['clean']                                         // remove formatting
    ],
    clipboard: {
        matchVisual: false,
    }
};

const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video',
    'color', 'background',
    'font',
    'align',
    'code-block',
    'script',
    'direction'
];
const CreateHelp = () => {
    const { id } = useParams();
    const loading = useSelector(Loading)
    const pre_module = useSelector(selectedModule);
    const process = useSelector(selectedProcess);
    const isReadonly = useSelector(isReadonlyFeild);
    const allModule = useSelector(allModules);
    const allProcessesList = useSelector(allProcessLists)
    const processesList = useSelector(allprocessListByModuleId);
    const editProcess = useSelector(processDetail);
    const location = useLocation();
    const navigate = useNavigate()

    const { prefilled } = location.state || {};
    const dispatch = useDispatch()

    const parentIds = new Set(allModule.map(mod => mod.parent_id).filter(Boolean));
const moduleOptions = allModule
  .filter(mod => !(mod.parent_id === null && parentIds.has(mod.id))) // remove parents with children
  .map(mod => {
    if (mod.parent_id !== null) {
      const parent = allModule.find(item => item.id === mod.parent_id);
      return {
        value: mod.id,
        label: `${parent?.name} - ${mod.name}`,
      };
    } else {
      return {
        value: mod.id,
        label: mod.name,
      };
    }
  });
    const AllProcessList = processesList.length>0? processesList.map((item) => ({
        value: item.id,
        label: item.process_name
    })):[];

    const initialValues = {
        module: pre_module ? pre_module.name : "",
        process: process ? process.name : "",
        active: id ? editProcess.status : 1,
        title: id ? editProcess.title : "",
        content: id ? editProcess.content : "",
    };
    const commonNavigate = (path) => {
        navigate(path)
    }

    const handleSubmit = async (values) => {
        let data = {
            "module_submodule_id": prefilled && pre_module ? pre_module.id : values.module,
            "title": values.title,
            "help_process_id": prefilled && process ? process.id : values.process,
            "content": values.content,
            "status": values.active,
        }
        if (id) {
            let payload = { ...data, id: parseInt(id), search: '' }
            await dispatch(updateFaq({ payload }))
        } else if (prefilled && pre_module && process) {
            await dispatch(addNewFaq(data))
        }

        else {
            let module = allModule.find((op) => op.id === values.module)
            let storeProcess = allProcessesList.find((op) => op.id === values.process)
            let process = {
                id: storeProcess?.id, name: storeProcess?.process_name
            }
            await dispatch(enableIsReadonly())
            await dispatch(enableModule(module))
            await dispatch(enableProcess(process))
            await dispatch(addNewFaq(data))
        }
        commonNavigate('/bmr/faq/listing');
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleSubmit,
        enableReinitialize: true
    })
    const formOptions = [{
        label: 'Module',
        type: prefilled && pre_module ? 'text' : 'select',
        name: 'module',
        placeholder: "Select a module",
        options: prefilled && pre_module ? pre_module.name : moduleOptions,
        required: true,
        disabled: isReadonly,
    },
    {
        label: 'Process',
        type: prefilled && process ? 'text' : 'select',
        name: 'process',
        placeholder: "Select a process",
        options: prefilled && process ? process.name : AllProcessList,
        required: true,
        disabled: isReadonly,
    },
    {
        label: 'Title',
        type: 'text',
        name: 'title',
        required: true,
        placeholder: "Enter the title",
    },
    {
        label: 'Status',
        type: 'select',
        name: 'active',
        placeholder: "Select a status",
        align: "center",
        options: [
            { value: 1, label: 'Active' },
            { value: 0, label: "In-Active" },
        ]
    },
    ];

    useEffect(() => {
        dispatch(fetchAllModules());
    }, []);

    useEffect(() => {
        if (formik.values.module) {
            dispatch(processesByModuleId(formik.values.module))
        }
    }, [formik.values.module]);
    useEffect(() => {
        if (process?.id) {
            dispatch(listingByProcessId({ params: { id: process.id, status: 1 } }));
        }
    }, [process?.id]);


    useEffect(() => {
        setTimeout(() => {
          const toolbarButtons = document.querySelectorAll('.ql-toolbar button, .ql-toolbar .ql-picker');
          toolbarButtons.forEach((button) => {
            if (button.classList.contains('ql-bold')) button.title = 'Bold';
            else if (button.classList.contains('ql-italic')) button.title = 'Italic';
            else if (button.classList.contains('ql-underline')) button.title = 'Underline';
            else if (button.classList.contains('ql-strike')) button.title = 'Strikethrough';
            else if (button.classList.contains('ql-header')) button.title = 'Header';
            else if (button.classList.contains('ql-blockquote')) button.title = 'Blockquote';
            else if (button.classList.contains('ql-code-block')) button.title = 'Code Block';
            else if (button.classList.contains('ql-list') && button.value === 'ordered') button.title = 'Numbered List';
            else if (button.classList.contains('ql-list') && button.value === 'bullet') button.title = 'Bullet List';
            else if (button.classList.contains('ql-script') && button.value === 'sub') button.title = 'Subscript';
            else if (button.classList.contains('ql-script') && button.value === 'super') button.title = 'Superscript';
            else if (button.classList.contains('ql-indent') && button.value === '-1') button.title = 'Decrease Indent';
            else if (button.classList.contains('ql-indent') && button.value === '+1') button.title = 'Increase Indent';
            else if (button.classList.contains('ql-direction')) button.title = 'Text Direction';
            else if (button.classList.contains('ql-color')) button.title = 'Text Color';
            else if (button.classList.contains('ql-background')) button.title = 'Background Color';
            else if (button.classList.contains('ql-font')) button.title = 'Font';
            else if (button.classList.contains('ql-align')) button.title = 'Alignment';
            else if (button.classList.contains('ql-link')) button.title = 'Insert Link';
            else if (button.classList.contains('ql-image')) button.title = 'Insert Image';
            else if (button.classList.contains('ql-video')) button.title = 'Insert Video';
            else if (button.classList.contains('ql-clean')) button.title = 'Remove Formatting';
          });
        }, 300);
      }, []);      

    const handleBackNav = () => {
        dispatch(clearDetailOfFaq()) //@info clear the state of the Faq
        if(!id){

            commonNavigate('/bmr/faq')
        }else{
            commonNavigate('/bmr/faq/listing');
        }
    }

    return <div className="!p-6">
        <button className="cursor-pointer mr-1 sm:mr-3 flex gap-2" onClick={handleBackNav}>
            <BackNavIcon /> Back
        </button>
        <div className="!p-4 mt-3 bg-white flex flex-col gap-4 rounded-2xl">
            <Typography variant="h3" component="h2" className='text-center'>
                {id ? 'Edit FAQ' : 'Add FAQ'}
            </Typography>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2} className="mb-3">
                        {formOptions.map((props, key) => (
                            <Grid key={key} item xs={12} sm={6}>
                                <FormikControl formik={formik} {...props} />
                            </Grid>
                        ))}
                    </Grid>
                    <Typography className='pb-1'>Content</Typography>
                    <div className="bg-[#F0F1F5] border-0">
                        <ReactQuill
                            theme="snow"
                            value={formik.values.content}
                            onChange={val => formik.setFieldValue("content", val)}
                            modules={modules}
                            formats={formats}
                            placeholder="Write something amazing..."
                        />
                        {formik.touched.content && formik.errors.content && (
                            <Typography variant="body2" color="error">
                                {formik.errors.content}
                            </Typography>
                        )}
                    </div>

                    <Grid container spacing={2} className="mt-3">
                        <Grid item xs={12} className='flex justify-center'>
                            <LoadingButton loading={loading} type="submit" variant="contained">{id ? "Update " : "Submit"}</LoadingButton>
                        </Grid>
                    </Grid>

                </form>

        </div>
    </div>
}
export default CreateHelp